export enum pendingJobsheetTatReportsActions {
    GET_PENDING_JOBSHEETS_TAT_REPORTS_LOADING = "@@pendingJobsheetTatReports/GET_PENDING_JOBSHEETS_TAT_REPORTS_LOADING",
    GET_PENDING_JOBSHEETS_TAT_REPORTS_SUCCESS = "@@pendingJobsheetTatReports/GET_PENDING_JOBSHEETS_TAT_REPORTS_SUCCESS",
    GET_PENDING_JOBSHEETS_TAT_REPORTS_ERROR = "@@pendingJobsheetTatReports/GET_PENDING_JOBSHEETS_TAT_REPORTS_ERROR",
  }